import { z } from 'zod';
import {
    PopularServicesGroupCateringModelSchema,
    PopularServicesGroupCulinaryStudioModelSchema,
    PopularServicesGroupDeliveryModelSchema,
    PopularServicesGroupModelSchema,
    PopularServicesGroupOutdoorBarModelSchema,
    PopularServicesGroupSweetShopModelSchema,
} from 'entities/popular-services-group';
import { GetPopularServicesGroupApiResponseSchema } from '../store';

export const createPopularServicesGroupFromGetPopularServicesGroupApiResponse = (
    (response: z.infer< typeof GetPopularServicesGroupApiResponseSchema>) => (
        PopularServicesGroupModelSchema.parse({
            catering: PopularServicesGroupCateringModelSchema.parse({
                image: response.data.catering?.image && {
                    url: response.data.catering.image.url,
                },
                formats: response.data.catering?.formats?.map(({
                    slug,
                    name,
                    shortDescription,
                }) => ({
                    uid: slug,
                    name,
                    shortDescription,
                })),
            }),
            delivery: PopularServicesGroupDeliveryModelSchema.parse({
                image: response.data.delivery?.image && {
                    url: response.data.delivery.image.url,
                },
                articleCategories: response.data.delivery?.articleCategories?.map(({
                    slug,
                    name,
                    shortDescription,
                }) => ({
                    uid: slug,
                    name,
                    shortDescription,
                })),
            }),
            culinaryStudio: PopularServicesGroupCulinaryStudioModelSchema.parse({
                image: response.data.culinaryStudio?.image && {
                    url: response.data.culinaryStudio.image.url,
                },
                articleCategories: response.data.culinaryStudio?.articleCategories?.map(({
                    slug,
                    name,
                    shortDescription,
                }) => ({
                    uid: slug,
                    name,
                    shortDescription,
                })),
            }),
            outdoorBar: PopularServicesGroupOutdoorBarModelSchema.parse({
                image: response.data.outdoorBar?.image && {
                    url: response.data.outdoorBar.image.url,
                },
                articleCategories: response.data.outdoorBar?.articleCategories?.map(({
                    slug,
                    name,
                    shortDescription,
                }) => ({
                    uid: slug,
                    name,
                    shortDescription,
                })),
            }),
            sweetShop: PopularServicesGroupSweetShopModelSchema.parse({
                image: response.data.sweetShop?.image && {
                    url: response.data.sweetShop.image.url,
                },
                articleCategories: response.data.sweetShop?.articleCategories?.map(({
                    slug,
                    name,
                    shortDescription,
                }) => ({
                    uid: slug,
                    name,
                    shortDescription,
                })),
            }),
        })
    )
);
